import React from 'react';
import {Line} from "react-chartjs-2";
import {Chart as ChartJs,CategoryScale,LinearScale,PointElement,
LineElement,Title,Tooltip,Legend} from "chart.js";

ChartJs.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);
const Chart = ({arr=[],currency,days}) => {
    const prices=[1,2,3];
    const date=["12/2/22","23/4/22","26/28/29"];
    for(let i=0; i<arr.length;i++){
        if(days==="24h")
        date.push(new Date(arr[i][0]).toLocaleTimeString());
        else
        date.push(new Date(arr[i][0]).toLocaleDateString());
        prices.push(arr[i][1]);
    }
    const data={
        labels:date,
        datasets:[
            {
            label:`Price in ${currency}`,
            data:prices,
            borderColor:"rgb(75, 192, 192)",
            backgroundColor:"rgb(75, 192, 192)",
        },
    ],
    };
  return (
    <Line options={{
        responsive:true,
    }}
    data={data}
    />
  );
};

export default Chart;